import { render, staticRenderFns } from "./HealthList.vue?vue&type=template&id=2379a46e&scoped=true&"
import script from "./HealthList.vue?vue&type=script&lang=js&"
export * from "./HealthList.vue?vue&type=script&lang=js&"
import style0 from "./HealthList.vue?vue&type=style&index=0&id=2379a46e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379a46e",
  null
  
)

component.options.__file = "HealthList.vue"
export default component.exports